import { useEffect } from 'react';

export const useForceLightThemePage = (enabled: boolean = true): void => {
  useEffect(() => {
    if (typeof document === 'undefined' || !enabled) {
      return;
    }

    const root = document.documentElement;
    let shouldRestoreDark = root.classList.contains('dark');
    root.classList.remove('dark');

    const observer = new MutationObserver(() => {
      if (root.classList.contains('dark')) {
        shouldRestoreDark = true;
        root.classList.remove('dark');
      }
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });

    return () => {
      observer.disconnect();
      if (shouldRestoreDark) {
        root.classList.add('dark');
      }
    };
  }, [enabled]);
};
